module.exports = __webpack_public_path__ + "static/media/openai.20abca60.svg";